import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem } from './../../../styles';
import StyledCalendar from '../../calendar/calendar.styles';
var defaultStyles = /*#__PURE__*/css(StyledCalendar, "{margin:", rem(8), " auto 0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var resetStyles = getResetByTag('div');
var StyledDatePickerCalendar = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1ykfs4j0"
} : {
  target: "e1ykfs4j0",
  label: "StyledDatePickerCalendar"
})(resetStyles, defaultStyles);
export default StyledDatePickerCalendar;